import { useMutation } from '@tanstack/react-query'
import { z } from 'zod'
import { branchSchema, repositorySchema } from '@basehub/data/replicache/index'
import { getURL } from '@basehub/shared-constants'
import { getClerkSessionFromCookie } from '~/replicache/frontend/get-clerk-session-from-cookie'

export const useCreateRepoMutation = () => {
  return useMutation(
    async ({
      title,
      startPrompt,
      teamId,
      userId,
      template,
      visibility,
    }: {
      title: string | null
      startPrompt?: string | null
      teamId: string
      userId: string
      template: string
      visibility: 'public' | 'private'
    }) => {
      const res = await fetch(
        getURL(
          'pump',
          process.env.NEXT_PUBLIC_ENVIRONMENT as 'production' | undefined
        ) + `/replicache/create-repository`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-basehub-session': getClerkSessionFromCookie() || '',
          },
          body: JSON.stringify({
            teamId,
            startPrompt,
            title,
            userId,
            template,
            isPublic: visibility === 'public',
          }),
        }
      )
      const resData = await res.json()
      if (res.status !== 200) {
        const parsedResData = z.object({ error: z.string() }).parse(resData)
        throw new Error(parsedResData.error)
      }
      const parsedResData = z
        .object({
          repoSpaceId: z.string(),
          repo: repositorySchema,
          templateIdSeed: z.string().nullable(),
          firstBranch: branchSchema,
        })
        .parse(resData)

      return parsedResData
    }
  )
}
